module.exports = __webpack_public_path__ + "img/pro_ground.24adad1f.png";